import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import * as Sentry from "@sentry/angular";
import { BrowserTracing } from '@sentry/tracing';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { registerLicense } from '@syncfusion/ej2-base';

Sentry.init({
  dsn: environment.sentry.dsn,
  release: environment.sentry.release,
  environment: environment.sentry.environment,  
  integrations: [
    Sentry.replayIntegration({
      maskAllText: false,
      maskAllInputs: false,
      blockAllMedia: false
    })
  ],
  beforeSend(event) {
        const msg = event.message || '';

        // Errores conocidos de extensiones de browser
        if (
          msg.includes('xbrowser is not defined') ||
          msg.includes('swbrowser is not defined') ||
          msg.includes('Java object is gone')
        ) {
          return null;
        }

        return event;
  },
  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0 // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});


if (environment.production) {
  enableProdMode();
}

// Licencia Syncfusion (Essential Studio 34.x)
registerLicense(environment.syncfusionLicenseKey);

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
